/**
 * Created by wb-zxs269841 on 2018/3/6.
 */
import AmapApp from '@ali/amap-lib';

let _amapSchema;
let _hasCalledAmap = false;
/**
 * 使用 schema 呼起高德地图.
 * @param {String} schema 呼起高德地图使用的 schema
 */
function openAmap(schema) {
  // android 不支持 schema 手机：
  //   华为NXT-DL00 EMUI4.0 android6.0 系统浏览器
  // 6677 端口返回 true 却无法呼起手机：
  //   魅族 note2
  //   uc 浏览器 9.4.2
  // loadSchema(schema);
  if (schema.indexOf('androidamap://') !== 0) {
    loadSchema(schema);
  } else {
    _amapSchema = schema;
    // callback 名称不可以 下划线 开头
    AmapApp.util.addScript(
      `http://127.0.0.1:6677/getpackageinfo?callback=amapCallback1&r=${Math.random()}`
    );
    setTimeout(() => {
      console.log(`400ms${_hasCalledAmap}`);
      if (!_hasCalledAmap) {
        console.log('loadschema');
        loadSchema(schema);
      }
    }, 400);
  }
}
// Android socket服务获取高德地图版本信息回调
window.amapCallback1 = function (data) {
  console.log(JSON.stringify(data));
  if (
    data
    && data.error_code == '0'
    && data.version_code >= 420
    && data.package === 'com.autonavi.minimap'
  ) {
    const schema = _amapSchema.replace(/^\w+map:\/\//i, '').replace('?', '&');
    AmapApp.util.addScript(
      `http://127.0.0.1:6677/androidamap?action=${schema}&callback=amapCallback2&r=${Math.random()}`
    );
  }
};
window.amapCallback2 = function (data) {
  console.log(JSON.stringify(data));
  // TODO 呼起失败时也返回 error_code === 0
  // 复现机型： 魅族note2 华为
  if (data.error_code == '0') {
    _hasCalledAmap = true;
  }
};

/**
 * 调用客户端schema.
 * @param {String} schema schema
 */
function loadSchema(schema) {
  if (AmapApp.os.ios && parseInt(AmapApp.os.version) >= 9) {
    window.location.href = schema;
    return;
  }

  let schemaIframe = document.getElementById('loadSchemaIframe');
  if (!schemaIframe) {
    schemaIframe = document.createElement('iframe');
    schemaIframe.id = 'loadSchemaIframe';
    schemaIframe.style.display = 'none';
    document.body.appendChild(schemaIframe);
  }
  schemaIframe.src = schema;
}
const browserApi = {
  openAmap
};
export default browserApi;
